import { TableHeaderRow, TableRow } from "@ucchub/ui";
import SimpleGrid from "@vfuk/core-simple-grid";
import { CommercialCriteria } from "@components/customer/CommercialCriteria.types";
import { Country } from "@components/country/Country.types";
import { useTranslation } from "react-i18next";
import useUseCase from "@hooks/useCase/useUseCase";
import useServiceType from "@hooks/serviceType/useServiceType";
import useNumberType from "@ucchub/ui/src/cloudNumbers/hooks/numberType/useNumberType";

import { useEffect } from "react";

type CommercialCriteriaTableProps = {
  commercialCriteria: CommercialCriteria;
  countryList: Country[];
};

const CommercialCriteriaTable = (props: CommercialCriteriaTableProps) => {
  const { t } = useTranslation();

  const { fetchServiceTypeList, serviceTypeList } = useServiceType();
  const { fetchUseCaseList, useCaseList } = useUseCase();
  const { fetchNumberTypeList, numberTypeList } = useNumberType();

  useEffect(() => {
    fetchNumberTypeList({
      countryId: props.commercialCriteria.countryId,
    });
    fetchServiceTypeList({
      "ids[]": [props.commercialCriteria.serviceTypeId],
      countryId: props.commercialCriteria.countryId,
      numberTypeId: props.commercialCriteria.numberTypeId,
    });
    fetchUseCaseList({
      countryId: props.commercialCriteria.countryId,
      numberTypeId: props.commercialCriteria.numberTypeId,
      serviceTypeId: props.commercialCriteria.serviceTypeId,
      "ids[]": [props.commercialCriteria.useCaseId],
    });
  }, [props.commercialCriteria]);

  const country = props.countryList.find(
    ({ id }) => id === props.commercialCriteria.countryId
  );

  const numberType = numberTypeList.find(
    ({ id }) => id === props.commercialCriteria.numberTypeId
  )?.name;

  const serviceType = serviceTypeList.find(
    ({ id }) => id === props.commercialCriteria.serviceTypeId
  )?.name;

  const useCase = useCaseList.find(
    ({ id }) => id === props.commercialCriteria.useCaseId
  )?.name;

  return (
    <>
      <SimpleGrid layout={{ sm: [12], lg: [12] }}>
        <>
          <TableHeaderRow
            headers={[
              t("core:billingContext:table:country"),
              t("core:billingContext:table:countryCode"),
              t("core:billingContext:table:number_type"),
              t("core:billingContext:table:service_type"),
              t("core:billingContext:table:use_case"),
              t("core:billingContext:table:billing_profile_id"),
            ]}
          />
          <TableRow
            rowData={[
              country?.name,
              "+" + country?.countryCode,
              numberType,
              serviceType,
              useCase,
              props.commercialCriteria.billingProfileId.abbreviation,
            ]}
          />
        </>
      </SimpleGrid>
    </>
  );
};

export default CommercialCriteriaTable;
